/**
 * 数字に対応する丸数字を返す（50まで取得可能）
 * @param number
 * @returns {string}
 */
export const parseNumberToCircleString = (number) => '⓪①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳㉑㉒㉓㉔㉕㉖㉗㉘㉙㉚㉛㉜㉝㉞㉟㊱㊲㊳㊴㊵㊶㊷㊸㊹㊺㊻㊼㊽㊾㊿'[number] || '';
/**
 * 改行削除
 * @param {string} string
 * @returns {string}
 */
export const removeLineBreaksFromString = (string) => string.replace(/\r?\n/g, '');
